module.exports = __webpack_public_path__ + "static/media/reporte2010.34b69f8a.png";